import { Component } from "react";
import { withAppData } from "../../app/withAppData";
import { API_FILE_URL } from "../../api/config";
import { fileUrl } from "../../i18n/i18n";
import { clean, has } from "../../utils/strings";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class BannerV3 extends Component {
  render() {
    const { slider, lang, loading } = this.props.appData;
    const sliders = Array.isArray(slider?.sliders) ? slider.sliders : [];

    const NextArrow = ({ onClick }) => (
      <button className="slick-next slick-arrow" onClick={onClick}>
        <i className="fas fa-arrow-right"></i>
      </button>
    );

    const PrevArrow = ({ onClick }) => (
      <button className="slick-prev slick-arrow" onClick={onClick}>
        <i className="fas fa-arrow-left"></i>
      </button>
    );

    const settings = {
      autoplay: true,
      autoplaySpeed: 4000,
      arrows: true,
      dots: false,
      fade: true,
      cssEase: "linear",
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <NextArrow />,
      prevArrow: <PrevArrow />,
    };

    return (
      <div className="ltn__slider-area banner__slider-area">
        {!loading && (
          <Slider {...settings}>
            {sliders.map((item, i) => {
              const t =
                item?.translations?.[lang] ||
                item?.translations?.tr ||
                item?.translations?.en ||
                {};

              const img = item?.image
                ? fileUrl(API_FILE_URL, clean(item.image))
                : null;

              const subtitle = clean(t.subtitle);
              const title = clean(t.title);
              const content = clean(t.content);

              const hasText = has(subtitle) || has(title) || has(content);

              return (
                <div key={i}>
                  <div
                    className={`banner-slide ${hasText ? "has-overlay" : ""}`}
                  >
                    {/* NEW — ARTIK IMG OLARAK KOYUYORUZ */}
                    <img src={img} alt="" className="banner-img" />

                    {/* YAZILAR */}
                    <div className="slide-content text-center">
                      {has(subtitle) && (
                        <h6 className="animated text-white">
                          <i className={clean(item.icon) || "fas fa-home"} />{" "}
                          {subtitle}
                        </h6>
                      )}
                      {has(title) && (
                        <h1 className="animated text-white">{title}</h1>
                      )}
                      {has(content) && (
                        <p className="animated text-white">{content}</p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
        )}
      </div>
    );
  }
}

export default withAppData(BannerV3);
